/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Commit_Message_PlaceholderInputs */

const en_team_sync_commit_message_placeholder = /** @type {(inputs: Team_Sync_Commit_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explain what change you made to this project.`)
};

const fr_team_sync_commit_message_placeholder = /** @type {(inputs: Team_Sync_Commit_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expliquez les changements que vous avez apportés à ce projet.`)
};

const de_team_sync_commit_message_placeholder = /** @type {(inputs: Team_Sync_Commit_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erläutern Sie, welche Änderung Sie an diesem Projekt vorgenommen haben.`)
};

const it_team_sync_commit_message_placeholder = /** @type {(inputs: Team_Sync_Commit_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiega quali modifiche hai apportato a questo progetto.`)
};

const ru_team_sync_commit_message_placeholder = /** @type {(inputs: Team_Sync_Commit_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объясните, какие изменения вы внесли в этот проект.`)
};

const es_team_sync_commit_message_placeholder = /** @type {(inputs: Team_Sync_Commit_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explique qué cambio realizó en este proyecto.`)
};

const zh_cn2_team_sync_commit_message_placeholder = /** @type {(inputs: Team_Sync_Commit_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请解释你对这个项目做了哪些改动。`)
};

const ja_team_sync_commit_message_placeholder = /** @type {(inputs: Team_Sync_Commit_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプロジェクトにどのような変更を加えたかを説明してください。`)
};

const hi_team_sync_commit_message_placeholder = /** @type {(inputs: Team_Sync_Commit_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपने इस प्रोजेक्ट में क्या बदलाव किए, इसका वर्णन करें।`)
};

const pt_pt2_team_sync_commit_message_placeholder = /** @type {(inputs: Team_Sync_Commit_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explique qual alteração você fez neste projeto.`)
};

/**
* | output |
* | --- |
* | "Explain what change you made to this project." |
*
* @param {Team_Sync_Commit_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_commit_message_placeholder = /** @type {((inputs?: Team_Sync_Commit_Message_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Commit_Message_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_commit_message_placeholder(inputs)
	if (locale === "de") return de_team_sync_commit_message_placeholder(inputs)
	if (locale === "it") return it_team_sync_commit_message_placeholder(inputs)
	if (locale === "ru") return ru_team_sync_commit_message_placeholder(inputs)
	if (locale === "es") return es_team_sync_commit_message_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_commit_message_placeholder(inputs)
	if (locale === "ja") return ja_team_sync_commit_message_placeholder(inputs)
	if (locale === "hi") return hi_team_sync_commit_message_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_commit_message_placeholder(inputs)
	return en_team_sync_commit_message_placeholder(inputs)
});